<template>
    <!-- <button @click="handleDelete">Edit</button>
    <button @click="handleEdit">Delete</button> -->
    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-4">
        <div :class="detail === 'past' ? 'card-his' : 'card-rdv'">
            <div :class="detail === 'past' ? 'card-his-date' : 'card-rdv-date'">
                <span>
                    <svg v-if="detail === 'incoming'" width="25" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.47852 9.79592H23.5305" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.4964 13.8649H18.5068" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.5042 13.8649H13.5146" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.50222 13.8649H8.51264" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.4964 17.9112H18.5068" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.5042 17.9112H13.5146" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.50222 17.9112H8.51264" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.0484 2.08334V5.51124" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.96055 2.08334V5.51124" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.268 3.72723H8.74233C5.43856 3.72723 3.375 5.43133 3.375 8.56372V17.9904C3.375 21.1721 5.43856 22.9156 8.74233 22.9156H18.2576C21.5718 22.9156 23.625 21.2016 23.625 18.0692V8.56372C23.6354 5.43133 21.5822 3.72723 18.268 3.72723Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <svg v-else width="25" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.47852 9.79592H23.5305" stroke="#271C49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.4964 13.8649H18.5068" stroke="#271C49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.5042 13.8649H13.5146" stroke="#271C49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.50222 13.8649H8.51264" stroke="#271C49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.4964 17.9112H18.5068" stroke="#271C49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.5042 17.9112H13.5146" stroke="#271C49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.50222 17.9112H8.51264" stroke="#271C49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.0484 2.08334V5.51124" stroke="#271C49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.96055 2.08334V5.51124" stroke="#271C49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.268 3.72723H8.74233C5.43856 3.72723 3.375 5.43133 3.375 8.56372V17.9904C3.375 21.1721 5.43856 22.9156 8.74233 22.9156H18.2576C21.5718 22.9156 23.625 21.2016 23.625 18.0692V8.56372C23.6354 5.43133 21.5822 3.72723 18.268 3.72723Z" stroke="#271C49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    {{ formatDate(rdv.start_date) }}
                </span>
                <span class="mx-4"><svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Iconly/Light/Time Circle">
                    <g id="Time Circle">
                    <path id="Stroke 1" fill-rule="evenodd" clip-rule="evenodd" d="M21.252 11.8854C21.252 16.9944 17.111 21.1354 12.002 21.1354C6.89295 21.1354 2.75195 16.9944 2.75195 11.8854C2.75195 6.77641 6.89295 2.63541 12.002 2.63541C17.111 2.63541 21.252 6.77641 21.252 11.8854Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path id="Stroke 3" d="M15.4321 14.3202L11.6621 12.1649V7.5199" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    </g>
                    </svg>
                    {{ formatDuration(rdv.start_date, rdv.end_date) }}
                </span>
                <!-- Uncomment after making the logic to delete past appointments -->
                <!-- <span v-if="detail === 'past'" @click="handleDelete" class="ml-4 float-end">
                    <svg @click="handleClick" style="cursor: pointer;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 21C6.45 21 5.97934 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6C4.71667 6 4.47934 5.904 4.288 5.712C4.09667 5.52 4.00067 5.28267 4 5C3.99934 4.71733 4.09534 4.48 4.288 4.288C4.48067 4.096 4.718 4 5 4H9C9 3.71667 9.096 3.47933 9.288 3.288C9.48 3.09667 9.71734 3.00067 10 3H14C14.2833 3 14.521 3.096 14.713 3.288C14.905 3.48 15.0007 3.71733 15 4H19C19.2833 4 19.521 4.096 19.713 4.288C19.905 4.48 20.0007 4.71733 20 5C19.9993 5.28267 19.9033 5.52033 19.712 5.713C19.5207 5.90567 19.2833 6.00133 19 6V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM17 6H7V19H17V6ZM10 17C10.2833 17 10.521 16.904 10.713 16.712C10.905 16.52 11.0007 16.2827 11 16V9C11 8.71667 10.904 8.47933 10.712 8.288C10.52 8.09667 10.2827 8.00067 10 8C9.71734 7.99933 9.48 8.09533 9.288 8.288C9.096 8.48067 9 8.718 9 9V16C9 16.2833 9.096 16.521 9.288 16.713C9.48 16.905 9.71734 17.0007 10 17ZM14 17C14.2833 17 14.521 16.904 14.713 16.712C14.905 16.52 15.0007 16.2827 15 16V9C15 8.71667 14.904 8.47933 14.712 8.288C14.52 8.09667 14.2827 8.00067 14 8C13.7173 7.99933 13.48 8.09533 13.288 8.288C13.096 8.48067 13 8.718 13 9V16C13 16.2833 13.096 16.521 13.288 16.713C13.48 16.905 13.7173 17.0007 14 17Z" fill="#271C49"/>
                    </svg>
                </span> -->
            </div>
            <div class="card-ctn-his">
                <div class="card-his-infos pb-2">
                    <div class="row">
                        <div class="col-lg-12">
                            <h6><span>Prestation{{rdv.prestations?.length > 1 ? 's':''}}:</span> {{rdv.prestations_list.split(',').at(0) }} <span>{{ rdv.prestations.length > 1 ? `( +${rdv.prestations.length - 1} )` : '' }}</span></h6>
                            <h6><span>Avec: </span> {{rdv.agenda.internet_name || rdv.agenda.name}}</h6>
                            <h6><span>Lieu: </span>{{rdv.location?.name || rdv.agenda.location.name || ''}} </h6>
                            <h6><span>Adresse: </span>{{rdv.location?.address || rdv.agenda.location.address}}</h6>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <h6><span> Prix: </span> {{ formatPrice(rdv.price)}} </h6>
                        </div>
                        <div class="col-lg-6">
                            <h6><span> Durée: </span>{{ getDuration(rdv.start_date, rdv.end_date) }}</h6>
                        </div>
                    </div>
                </div>
                <div v-if="detail === 'incoming'" class="card-rdv-btns">
                    <button v-if="can_modify(rdv)" class="btn-primary1" @click="handleEdit">Reprogrammer</button>
                    <!-- <button class="btn-cancel"  @confirm="handleDelete" @cancel="this.show = false" :show="this.show">Annuler</button> -->
                    <div v-if="can_cancel(rdv)" class="btn-cancel text-center" role="button" @click="this.show = true"> Annuler </div>
                    <AnnulationPopUp @confirm="handleDelete" v-model:show="show"></AnnulationPopUp>
                </div>
            </div>
        </div>
    </div>
</template> 

<script>
import moment from 'moment'
import AnnulationPopUp from './AnnulationPopUp.vue'
import { BookingStore } from '../Stores/BookingStore'
export default {
    name : 'EventCard',
    props : ['rdv', 'detail'],
    emits : ['delete-rdv', 'edit-rdv'],
    data () {
        return {
            show: false
        }
    },
    components: { AnnulationPopUp },
    computed: {
            config() {
                return this.$page.props.config
            },
    },
    methods : {
        handleDelete() {
            this.$emit('delete-rdv', this.rdv)
        },
        handleEdit() {
            BookingStore.set_step(1)
            this.$emit('edit-rdv', this.rdv)
        },
        handleClick() {
            console.log("Clicked!!!")
        },
        formatDate (d) {
            if (!d) return ''
            return moment(d).locale('fr').format('DD/MM/YYYY')
        },
        formatDuration (d, endDate) {
            if (!d || !endDate ) return ''
            return "De " + moment(d).locale('fr').format('HH:mm') + " à " + moment(endDate).locale('fr').format('HH:mm');
        },
        getDuration (d, endDate) {
            if (!d || !endDate ) return ''
            const duration = moment.duration(moment(endDate).diff(moment(d)))
            return duration.hours() ? `${duration.hours()}h${duration.minutes()} min.` : `${duration.minutes()} min.`
        },
        formatPrice(price) {
            let val
            val = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(price)
            return (val)
        },
        can_modify(rdv){
            return this.time_is_valid(rdv) && this.is_permit_by_prestation(rdv.prestation.prestation_id,'CAN_MODIFY_ONLINE_BY_PRESTATION');
        },
        can_cancel(rdv){
            if (!this.config.allow_client_delete_rdv) return false;
            return this.time_is_valid(rdv) && this.is_permit_by_prestation(rdv.prestation.prestation_id,'CAN_DELETE_ONLINE_BY_PRESTATION');
        },
        time_is_valid(rdv) { // date non expiré
            if (!this.config.last_annulation_time) return true
            let date_rdv = moment().add(this.config.last_annulation_time, 'hours')
            return date_rdv.isBefore(moment(rdv.start_date).format('YYYY-MM-DD HH:mm:ss'))
        },
        is_permit_by_prestation(prestation_id, permission_key){
            if(this.config[permission_key+'-'+prestation_id] == undefined || this.config[permission_key+'-'+prestation_id] == null || this.config[permission_key+'-'+prestation_id]?.target_value == 1){
                return true;
            }
            return false;
        }
    },
    mounted() {
        
    } 
}
</script>

<style>
    .mon-compte .card-rdv-btns{
        justify-content: end;
        padding: 1rem;
    }
</style>